function checkScrollPosition() {
    var element = document.querySelector('.start-scroller-menu');
    var header = document.querySelector('.main-header');

    if (element && header) {
        var rect = element.getBoundingClientRect();

        if ((rect.bottom - 80) <= 0) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }
    }
}

jQuery(document).ready(function ($) {
    window.addEventListener('scroll', checkScrollPosition);

    /* Clients logos carousel */
    var clientsCarousel = $(".clients-carousel .owl-carousel");
    if (clientsCarousel.length > 0 && typeof clientsCarousel.owlCarousel === 'function') {
        clientsCarousel.owlCarousel({
            loop: true,
            margin: 0,
            dots: false,
            autoplay: true,
            autoplayHoverPause:true,
            nav: true,
            navText: [
                '<span uk-icon="icon: arrow-left; ratio: 2"></span>',
                '<span uk-icon="icon: arrow-right; ratio: 2"></span>'
            ],
            responsive: {
                0: { items: 3, margin: 20},
                600: { items: 4, margin: 20 },
                1000: { items: 6 },
                1400: { items: 8 }
            }
        });
    }


    /* Counter Up */
    if (typeof $.fn.counterUp === 'function') {
        $('.number i').each(function () {
            var delay = $(this).data('delay') || 1000;
            $(this).counterUp({
                delay: 10,
                time: delay
            });
        });
    }
});
